<template>
	<section>
		<div class="row d-flex justify-content-center mt-2 mb-70">
			<div class="col-md-11">
				<div class="main-card mb-3">
					<b-overlay :show="loading" no-wrap rounded></b-overlay>
					<h3 v-if="items.length==0 && !loading">No se encontraron resultados</h3>
					<div class="vertical-timeline vertical-timeline--animate vertical-timeline--one-column" v-else>
						<div class="vertical-timeline-item vertical-timeline-element mb-5" v-for="(item,index) in items " :key="index" >
							<div>
								<span class="vertical-timeline-element-icon bounce-in">
									<b-badge :variant="getIconAndVariant(item.categoryType).variant">
										<md-icon :icon="getIconAndVariant(item.categoryType).icon"></md-icon>
									</b-badge>
								</span>
								<div class="vertical-timeline-element-content bounce-in">
									<h4 class="timeline-title mb-1">{{item.categoryTypeLabel}}</h4>
									<span> Realizado por <b>{{item.user}}</b></span>
									<p v-if="showChanges">
										<span v-for="(change,i) in item.changes" :key="i">{{change}}<br/></span>
									</p>
									<div class="vertical-timeline-element-date">{{formatDate(item.creationDatetime)}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<h3>Notificaciones al proveedor:</h3>
		<AjaxTable
			id="supplier-notifications-list"
			:filters="notifications.filters"
			:columns="columns"
			resource="supplier-notifications"
			responsive='sm'
			stacked="sm"
		>
			<template v-slot:cell(actions)="row">
				<div class="text-center">
					<b-button @click="showModalMailEvents(row.item.externalMessageId)" type="button" size="sm" class="mr-1" variant="info">
						<md-icon icon="events"/> Ver eventos
					</b-button>
				</div>
			</template>

			<template v-slot:cell(typeTag)="row">
				<span v-if="row.item.type ==='supplierCancelation'">
					<b-badge variant="danger">Cancelación</b-badge>
				</span>
				<span v-else>
					<b-badge variant="primary">Cambios</b-badge>
				</span>

			</template>
		</AjaxTable>

		<b-modal
			hide-footer
			size="xl"
			ref="mail-events-supplier-list"
			title="Eventos"
		>
			<MailEvents :messageId="notifications.messageIdSelected">
				<template v-slot:title>
					<h5>Message ID {{notifications.messageIdSelected}}</h5>
				</template>
			</MailEvents>
		</b-modal>
	</section>

</template>

<script>
import api from "../../../api.js";
import moment from 'moment'
import AjaxTable from '../../helpers/AjaxTable.vue'
import MailEvents from '../../helpers/ExternalMailEvents'
export default {
	components:{AjaxTable,MailEvents},
	data() {
        return {
			loading:false,
			showChanges:false,
			items:[],
			notifications:{
				filters: {transportServiceId: this.transportServiceId},
				messageIdSelected:null,
			},
			columns:[
				{key:'id',label:'ID',disabled: true},
				{key:'supplier.name',label:'Proveedor'},
				{key:'destination',label:'Destinatario'},
				{key:'creationDatetime',label:'Enviado'},
				{key:'typeTag',label:'Tipo'},
				{key:'actions',label:'Opciones'},
			]
        };
    },
    methods: {
        fetch() {
			this.loading=true;
            const params = {
                transportServiceId: this.transportServiceId,
            };
            api(this)
                .get("/transport-services/supplier/history", { params: params })
                .then((res) => {
                    this.items = res.data.items;
                })
                .finally(() => {
                    this.loading = false;
                });
		},
		getIconAndVariant(action){
			let icon ="";
			let variant ="";
			switch(action){
				case "pending":
					icon    = "pending_actions"
					variant = "primary"
					break;
				case "rejected":
					icon    = "thumb_down_off_alt"
					variant = "danger"
					break;
				case "confirmed":
					icon   ="done"
					variant = "success";
					break;
				case "assigned":
					icon    = "published_with_changes"
					variant = "info"
					break;
				default:
					icon   = "help_outline"
					variant = "warning";
					break;
			}
			return {
				icon:icon,
				variant:variant
			}
		},
		formatDate(dateTime) {
          return moment(dateTime).format('dddd, D MMM YYYY HH:mm');

        },
		showModalMailEvents(messageId){
			this.notifications.messageIdSelected = messageId;
			this.$refs["mail-events-supplier-list"].show();
		}
    },
    props: {
        transportServiceId: {
            required: true,
            type: Number,
            default: -1,
        },
    },
    computed: {
    },
    mounted() {
		this.fetch();
	},
    watch: {},
};
</script>

<style scoped>

.mt-70 {
    margin-top: 70px
}

.mb-70 {
    margin-bottom: 70px
}

.card {
    box-shadow: 0 0.46875rem 2.1875rem rgba(4, 9, 20, 0.03), 0 0.9375rem 1.40625rem rgba(4, 9, 20, 0.03), 0 0.25rem 0.53125rem rgba(4, 9, 20, 0.05), 0 0.125rem 0.1875rem rgba(4, 9, 20, 0.03);
    border-width: 0;
    transition: all .2s
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(26, 54, 126, 0.125);
    border-radius: .25rem
}

.card-body {
    flex: 1 1 auto;
    padding: 1.25rem
}

.vertical-timeline {
    width: 100%;
    position: relative;
    padding: 1.5rem 0 1rem
}

.vertical-timeline::before {
    content: '';
    position: absolute;
    top: 0;
    left: 67px;
    height: 100%;
    width: 4px;
    background: #e9ecef;
    border-radius: .25rem
}

.vertical-timeline-element {
    position: relative;
    margin: 0 0 1rem
}

.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
    visibility: visible;
    animation: cd-bounce-1 .8s
}

.vertical-timeline-element-icon {
    position: absolute;
    top: 0;
    left: 60px
}

.vertical-timeline-element-icon .badge-dot-xl {
    box-shadow: 0 0 0 5px #fff
}

.badge-dot-xl {
    width: 18px;
    height: 18px;
    position: relative
}

.badge:empty {
    display: none
}

.badge-dot-xl::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: .25rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -5px 0 0 -5px;
    background: #fff
}

.vertical-timeline-element-content {
    position: relative;
    margin-left: 100px;
    font-size: .8rem
}

.vertical-timeline-element-content .timeline-title {
    font-size: .8rem;
    text-transform: uppercase;
    margin: 0 0 .5rem;
    padding: 2px 0 0;
    font-weight: bold
}

.vertical-timeline-element-content .vertical-timeline-element-date {
    display: block;
    position: absolute;
    left: -120px;
    top: 0;
    padding-right: 9px;
    text-align: right;
    color: #adb5bd;
    font-size: .7619rem;
    /*white-space: nowrap;*/
	max-width: 5rem;
}

.vertical-timeline-element-content:after {
    content: "";
    display: table;
    clear: both
}


</style>
